<div
  class="bfx-blotter-filter-view-table"
  [ngClass]="{viewTableDisabled: editedItem==null || !edit}"
>
  <p-dataTable
    #dt
    [immutable]="false"
    [value]="editedItem!=null ? parseConditions(editedItem.conditions) : []"
    scrollable="true"
    scrollHeight="490px"
    [emptyMessage]="emptyMessage"
    [editable]="!saving"
    tableStyleClass="bfx-blotter__filter-manager__table"
    styleClass="bfx-blotter__filter-manager__styleclass"
    [rowStyleClass]="rowStyleClass"
  >
    <p-column [style]="{ 'width':'25px' , 'text-align' : 'center'}">
      <ng-template let-data="rowData" pTemplate="body">
        <div
          #addOrRm
          class="filter-icon-box-circle"
          [style.opacity]="!edit || data.iconDisabled ? '0.50' : '1.0'"
          [tabindex]="!edit || data.iconDisabled?-1:0"
          (keydown)="onKeydown($event, data)"
        >
          <label
            *ngIf="data && !data.or"
            class="icon"
            [style.cursor]="!edit || data.iconDisabled ? 'default' : 'pointer'"
            [ngClass]="{ 'icon-remove_circle bfx-id--filtermgr-remove': !data.add, 'icon-ion_add_circle_filled bfx-id-filtermgr-add' : data.add, 'iconDisabled' : data.iconDisabled || !edit }"
            (click)="addOrRemoveCondition(data)"
          >
          </label>
          <label
            *ngIf="data && data.or"
            class="icon icon-remove_circle bfx-id-filtermgr-remove"
            [style.cursor]="!edit ? 'default' : 'pointer'"
            (click)="removeOr(data)"
          >
          </label>
        </div>
      </ng-template>
    </p-column>
    <p-header>
      <label class="header-filter-label">Filter Name:</label>
      <span class="header-filter-text">{{editedItem ? editedItem.filterName : ''}}</span>
      <div class="divider"></div>
    </p-header>
    <p-column
      styleClass="editable"
      header="Attribute"
      [style]="{'width':'170px', 'overflow':'visible'}"
    >
      <ng-template let-col let-data="rowData" pTemplate="body">
        <bfx-autoComplete
          #aCompDrDown
          state="4"
          size="sm"
          appendTo="body"
          [disabled]="!edit"
          *ngIf="data && !data.add && !data.or"
          [(ngModel)]="data.conditionData"
          [suggestions]="columnSuggestions"
          (completeMethod)="searchColumn($event, data)"
          [dropdown]="true"
          [inputStyle]="{'width':'120px', 'margin-right': '1px'}"
          [delay]="5"
          (onSelect)="onSelectCondition(data)"
          autoHighlight="true"
          field="label"
          [skipBlur]="true"
          dataKey="value"
          [minLength]="0"
          [maxlength]="30"
          (onDropdownClick)="showColumnOptions($event, data)"
          [tabindex]="!edit?-1:0"
          (onFocusEditable)="focusEditableAttribute(aCompDrDown)"
          class="bfx-id-filtermgr-attrib"
        ></bfx-autoComplete>
      </ng-template>
    </p-column>
    <p-column
      styleClass="editable"
      header="Operator"
      [style]="{'width':'122px', 'overflow':'visible'}"
    >
      <ng-template let-col let-data="rowData" pTemplate="body">
        <span *ngIf="data && data.or">OR</span>
        <bfx-autoComplete
          *ngIf="data && !data.add && !data.or"
          #opCompDrDown
          state="4"
          autoHighlight="true"
          size="sm"
          appendTo="body"
          field="label"
          dataKey="value"
          dropdownMode="current"
          (completeMethod)="searchOperator($event, data)"
          (onSelect)="onSelectOperator(data)"
          (onDropdownClick)="showOperatorOptions($event, data)"
          (onFocusEditable)="focusEditableOperator(opCompDrDown, data)"
          [(ngModel)]="data.operatorData"
          [disabled]="!edit"
          [suggestions]="operatorSuggestions"
          [dropdown]="true"
          [inputStyle]="{'width':'75px', 'margin-right': '1px'}"
          [delay]="10"
          [minLength]="0"
          [maxlength]="30"
          [skipBlur]="true"
          [tabindex]="!edit?-1:0"
          [skipSorting]="true"
          class="bfx-id-filtermgr-operator"
        ></bfx-autoComplete>
      </ng-template>
    </p-column>
    <p-column styleClass="editable" field="value" header="Value" [style]="{'width':'202px'}">
      <ng-template
        let-data="rowData"
        let-column="rowData.conditionData.value"
        let-operator="rowData.operatorData.value"
        let-editableIndex="rowIndex"
        pTemplate="body"
      >
        <bfx-amount-spinner
          *ngIf="(columnFilterTypes[column]=='NUMBER' || columnFilterTypes[column]=='INT') && !betweenOperators[operator]"
          size="sm"
          [disabled]="!edit"
          [(ngModel)]="data.value"
          [showValidationBar]="false"
          [ngClass]="{itemDisabled: !edit}"
          [tabindex]="!edit?-1:0"
          class="bfx-id-filtermgr-val_amt"
        >
        </bfx-amount-spinner>
        <bfx-temperature-spinner
          *ngIf="(columnFilterTypes[column]=='PERCENTAGE') && !betweenOperators[operator]"
          size="sm"
          [disabled]="!edit"
          [precision]="2"
          [min]="minPercentageAway"
          [(ngModel)]="data.value"
          [ngClass]="{itemDisabled: !edit}"
          [tabindex]="!edit?-1:0"
          class="bfx-id-filtermgr-val_perc"
        >
        </bfx-temperature-spinner>
        <bfx-blotter-filter-selector
          #sel1
          panelStyleClass="bfx-multi-selector-dropdown bfx-blotter__filter-manager__selector"
          [disableInput]="!edit"
          size="sm"
          *ngIf="objectColumns[column] && multipleOperators[operator] && columnFilterTypes[column]!='CURRENCY_PAIR' && columnFilterTypes[column]!='DATE_TENOR'"
          [optionsLookupFn]="objectValuesLookupFn[data.fieldName]"
          [selectedOptions]="data.value"
          (selectedOptions)="selectOption(data, $event)"
          [options]="objectValues[column]"
          (keyup)="displayDropDown($event)"
          (focus)="focusTriggered($event, sel1, true)"
          (blur)="focusTriggered($event, sel1, false)"
          [ngClass]="{itemDisabled: !edit}"
          [tabindex]="!edit?-1:0"
          [proxyTab]="data.proxyTabSelector || proxyOnTabSelector(data, dt, editableIndex)"
          class="bfx-id-filtermgr-val_sel1"
        >
        </bfx-blotter-filter-selector>
        <bfx-blotter-filter-selector
          #sel5
          panelStyleClass="bfx-multi-selector-dropdown bfx-blotter__filter-manager__selector"
          [disableInput]="!edit"
          size="sm"
          *ngIf="columnFilterTypes[column]=='DATE_TENOR' && !betweenOperators[operator]"
          [selectedOptions]="getSelectedOptions(data, 'value')"
          (selectedOptions)="selectOption(data, $event)"
          [options]="objectValues[column]"
          (keyup)="displayDropDown($event)"
          (focus)="focusTriggered($event, sel5, true)"
          (blur)="focusTriggered($event, sel5, false)"
          [ngClass]="{itemDisabled: !edit}"
          [tabindex]="!edit?-1:0"
          [proxyTab]="data.proxyTabSelector || proxyOnTabSelector(data, dt, editableIndex)"
          [unsorted]="true"
          [optionSingleSelection]="true"
          class="bfx-id-filtermgr-val_sel5"
        >
        </bfx-blotter-filter-selector>
        <bfx-blotter-filter-selector
          #sel6
          panelStyleClass="bfx-multi-selector-dropdown bfx-blotter__filter-manager__selector"
          [disableInput]="!edit"
          size="sm"
          *ngIf="columnFilterTypes[column]=='DATE_TENOR' && betweenOperators[operator]"
          [selectedOptions]="getSelectedOptions(data, 'from')"
          (selectedOptions)="selectFromOption(data, $event)"
          [options]="objectValues[column]"
          (keyup)="displayDropDown($event)"
          (focus)="focusTriggered($event, sel6, true)"
          (blur)="focusTriggered($event, sel6, false)"
          [ngClass]="{itemDisabled: !edit}"
          [tabindex]="!edit?-1:0"
          [proxyTab]="data.proxyTabSelector || proxyOnTabSelector(data, dt, editableIndex)"
          [unsorted]="columnFilterTypes[column]=='DATE_TENOR'"
          [optionSingleSelection]="true"
          class="bfx-id-filtermgr-val_sel6"
        >
        </bfx-blotter-filter-selector>
        <bfx-blotter-filter-selector
          #sel7
          panelStyleClass="bfx-multi-selector-dropdown bfx-blotter__filter-manager__selector"
          [disableInput]="!edit"
          size="sm"
          *ngIf="columnFilterTypes[column]=='DATE_TENOR' && betweenOperators[operator]"
          [selectedOptions]="getSelectedOptions(data, 'to')"
          (selectedOptions)="selectToOption(data, $event)"
          [options]="objectValues[column]"
          (keyup)="displayDropDown($event)"
          (focus)="focusTriggered($event, sel7, true)"
          (blur)="focusTriggered($event, sel7, false)"
          [ngClass]="{itemDisabled: !edit}"
          [tabindex]="!edit?-1:0"
          [proxyTab]="data.proxyTabSelector || proxyOnTabSelector(data, dt, editableIndex)"
          [unsorted]="columnFilterTypes[column]=='DATE_TENOR'"
          [optionSingleSelection]="true"
          class="bfx-id-filtermgr-val_sel7"
        >
        </bfx-blotter-filter-selector>
        <bfx-blotter-filter-selector
          #sel2
          panelStyleClass="bfx-multi-selector-dropdown bfx-blotter__filter-manager__selector"
          [disableInput]="!edit"
          size="sm"
          *ngIf="objectColumns[column] && multipleOperators[operator] && columnFilterTypes[column]=='CURRENCY_PAIR'"
          [selectedOptions]="data.value"
          (selectedOptions)="selectOption(data, $event)"
          [options]="objectValues[column]"
          [altSelectedOptions]="data.altValue"
          (altSelectedOptions)="selectAltOption(data, $event)"
          [alternativeOptions]="currencyPairGroupData"
          [optionsLabel]="'Currency Pair'"
          (focus)="focusTriggered($event, sel2, true)"
          (blur)="focusTriggered($event, sel2, false)"
          [alternativeOptionsLabel]="'Ccy Pair Group'"
          [alternativeInclusive]="true"
          [showOptionsUpdatesText]="false"
          (keyup)="displayDropDown($event)"
          [ngClass]="{itemDisabled: !edit}"
          [tabindex]="!edit?-1:0"
          [proxyTab]="data.proxyTabSelector || proxyOnTabSelector(data, dt, editableIndex)"
          class="bfx-id-filtermgr-val_sel2"
        >
        </bfx-blotter-filter-selector>
        <bfx-blotter-filter-selector
          #sel3
          panelStyleClass="bfx-multi-selector-dropdown bfx-blotter__filter-manager__selector"
          [disableInput]="!edit"
          size="sm"
          *ngIf="objectColumns[column] && columnFilterTypes[column]=='TEMPERATURE'"
          [selectedOptions]="data.value"
          (selectedOptions)="selectOption(data, $event)"
          [options]="objectValues[column]"
          (keyup)="displayDropDown($event)"
          (focus)="focusTriggered($event, sel3, true)"
          (blur)="focusTriggered($event, sel3, false)"
          [ngClass]="{itemDisabled: !edit}"
          [optionSingleSelection]="true"
          [tabindex]="!edit?-1:0"
          [proxyTab]="data.proxyTabSelector || proxyOnTabSelector(data, dt, editableIndex)"
          class="bfx-id-filtermgr-val_sel3"
        >
        </bfx-blotter-filter-selector>
        <div
          class="bfx-radio-container"
          *ngIf="booleanColumns[column] && multipleOperators[operator]"
        >
          <p-radioButton
            [tabindex]="!edit?-1:0"
            name="{{data.conditionData.value}}"
            value="Yes"
            label="Yes"
            [(ngModel)]="data.value"
            inputId="yes"
            [disabled]="!edit"
            [ngClass]="{itemDisabled: !edit}"
            class="bfx-id-filtermgr-val_yes"
          ></p-radioButton>
          <p-radioButton
            [tabindex]="!edit?-1:0"
            name="{{data.conditionData.value}}"
            value="No"
            label="No"
            [(ngModel)]="data.value"
            inputId="no"
            [disabled]="!edit"
            [ngClass]="{itemDisabled: !edit}"
            class="bfx-id-filtermgr-val_no"
          ></p-radioButton>
        </div>
        <p-calendar
          #pCalValue
          panelStyleClass="bfx-calendar-sm"
          [patchDragAutoclose]="pCalValue"
          [disabled]="!edit"
          [locale]="en"
          [appendTo]="calendarPanelHelper"
          placeholder="{{getDataLabel(data, false)}}"
          *ngIf="columnFilterTypes[column]=='DATE' && !betweenOperators[operator]"
          [ngModel]="dateValue"
          (ngModelChange)="processCalendarValue($event, data)"
          showIcon="true"
          dateFormat="dd-M-y"
          [tabindex]="!edit?-1:0"
          icon="fa icon-calendar_month"
          class="bfx-id-filtermgr-val_cal"
        ></p-calendar>
        <bfx-amount-spinner
          *ngIf="(columnFilterTypes[column]=='NUMBER' || columnFilterTypes[column]=='INT') && betweenOperators[operator]"
          [disabled]="!edit"
          size="sm"
          [(ngModel)]="data.from"
          [showValidationBar]="false"
          [ngClass]="{itemDisabled: !edit}"
          [tabindex]="!edit?-1:0"
          class="bfx-id-filtermgr-val_num_between_from"
        >
        </bfx-amount-spinner>
        <bfx-amount-spinner
          *ngIf="(columnFilterTypes[column]=='NUMBER' || columnFilterTypes[column]=='INT') && betweenOperators[operator]"
          [disabled]="!edit"
          size="sm"
          [(ngModel)]="data.to"
          [showValidationBar]="false"
          [ngClass]="{itemDisabled: !edit}"
          [tabindex]="!edit?-1:0"
          class="bfx-id-filtermgr-val_num_between_to"
        >
        </bfx-amount-spinner>
        <bfx-temperature-spinner
          *ngIf="(columnFilterTypes[column]=='PERCENTAGE') && betweenOperators[operator]"
          [disabled]="!edit"
          [precision]="2"
          size="sm"
          [min]="minPercentageAway"
          [(ngModel)]="data.from"
          [ngClass]="{itemDisabled: !edit}"
          [tabindex]="!edit?-1:0"
          class="bfx-id-filtermgr-val_perc_between_from"
        >
        </bfx-temperature-spinner>
        <bfx-temperature-spinner
          *ngIf="(columnFilterTypes[column]=='PERCENTAGE') && betweenOperators[operator]"
          [disabled]="!edit"
          [precision]="2"
          size="sm"
          [min]="minPercentageAway"
          [(ngModel)]="data.to"
          [ngClass]="{itemDisabled: !edit}"
          [tabindex]="!edit?-1:0"
          class="bfx-id-filtermgr-val_perc_between_to"
        >
        </bfx-temperature-spinner>
        <p-calendar
          #pCalFrom
          panelStyleClass="bfx-calendar-sm"
          [patchDragAutoclose]="pCalFrom"
          [disabled]="!edit"
          [locale]="en"
          [appendTo]="calendarPanelHelper"
          placeholder="{{getDataLabel(data, false)}}"
          *ngIf="columnFilterTypes[column]=='DATE' && betweenOperators[operator]"
          [ngModel]="dateFromValue"
          (ngModelChange)="processCalendarValue($event, data, false)"
          showIcon="true"
          dateFormat="dd-M-y"
          [tabindex]="!edit?-1:0"
          icon="fa icon-calendar_month"
          class="bfx-id-filtermgr-val_cal_between_from"
        ></p-calendar>
        <p-calendar
          #pCalTo
          panelStyleClass="bfx-calendar-sm"
          [patchDragAutoclose]="pCalTo"
          [disabled]="!edit"
          [locale]="en"
          [appendTo]="calendarPanelHelper"
          placeholder="{{getDataLabel(data, true)}}"
          *ngIf="columnFilterTypes[column]=='DATE' && betweenOperators[operator]"
          [ngModel]="dateToValue"
          (ngModelChange)="processCalendarValue($event, data, true)"
          showIcon="true"
          dateFormat="dd-M-y"
          [tabindex]="!edit?-1:0"
          icon="fa icon-calendar_month"
          class="bfx-id-filtermgr-val_cal_between_to"
        ></p-calendar>
      </ng-template>
    </p-column>
  </p-dataTable>
</div>
<div class="button-line-false">
  <p-selectButton
    [options]="filterSelectionModes"
    [style]="{'visibility':'hidden'}"
  ></p-selectButton>
</div>
<div class="divider"></div>
<div class="bottom-bar">
  <button
    class="bfx-button-secondary"
    [disabled]="orDisabled() || editedItem==null || saving || !edit"
    style="float: left"
    (click)="appendOr()"
    [tabindex]="!edit?-1:0"
  >
    OR
  </button>
  <button
    class="bfx-button-negative bfx-blotter-filter-view__cancel"
    [disabled]="editedItem==null || saving || !edit"
    (click)="cancelFilterEditing()"
    [tabindex]="!edit?-1:0"
  >
    Cancel
  </button>
  <button
    class="bfx-button-primary"
    [disabled]="!shouldSave() || saving || !edit"
    (click)="save()"
    [tabindex]="!edit?-1:0"
  >
    Save
  </button>
</div>
